const generalForeignEntryRoles = new Set([
  'admin',
  'leiter',
  'lehrhöhenretter',
  'lehrhöhenretter_ausbildung',
  'lehrhöhenretter_technik',
  'lehrhöhenretter_einsatztaktik',
]);

const equipmentCheckForeignEntryRoles = new Set([
  'admin',
  'leiter',
  'einheitsführer',
  'geräteprüfer',
]);

const EQUIPMENT_CHECK_DAY_ENTRY_TYPE = 'Geräteprüfung (Tagesdienst)';

function normalizeIds(values = []) {
  return [...new Set((values || []).map(String).filter(Boolean))];
}

export function canDeselectOwnLogbook(userRoles = [], entryType = '') {
  const roles = Array.isArray(userRoles) ? userRoles : [];
  if (roles.some((role) => generalForeignEntryRoles.has(role))) {
    return true;
  }

  return entryType === EQUIPMENT_CHECK_DAY_ENTRY_TYPE
    && roles.some((role) => equipmentCheckForeignEntryRoles.has(role)
      || (typeof role === 'string' && role.startsWith('lehrhöhenretter')));
}

export function initializeLogbookTargetSelection(selectedUserIds, currentUserId) {
  const currentId = String(currentUserId || '');
  const selectedIds = normalizeIds(selectedUserIds);
  return currentId && !selectedIds.includes(currentId)
    ? [currentId, ...selectedIds]
    : selectedIds;
}

export function toggleLogbookTargetSelection({
  selectedUserIds,
  userOverrides,
  targetUserId,
  currentUserId,
  allowOwnDeselection,
}) {
  const targetId = String(targetUserId);
  const currentId = String(currentUserId || '');
  const selectedIds = normalizeIds(selectedUserIds);
  const overrides = { ...(userOverrides || {}) };
  const isSelected = selectedIds.includes(targetId);

  if (isSelected) {
    if (targetId === currentId && !allowOwnDeselection) {
      return { selectedUserIds: selectedIds, userOverrides: overrides };
    }

    delete overrides[targetId];
    return {
      selectedUserIds: selectedIds.filter((id) => id !== targetId),
      userOverrides: overrides,
    };
  }

  return {
    selectedUserIds: [...selectedIds, targetId],
    userOverrides: overrides,
  };
}